export function average(nums) {
    return nums.reduce((a, b) => a + b) / nums.length;
}
export function percent(n1, n2) {
    return (100 * n1) / n2;
}
export function round(n1, q = 4) {
    return Math.round(n1 * 10 ** q) / 10 ** q;
}
export function byMat(material) {
    const materials = {
        "<h4 title='Оцинкованная сталь' onmouseover='new Audio(`https://ilysan.ru/wp-content/themes/mesmerize-child/Оцинкованная сталь.mp3`).play();'>1️⃣➖Оц.<a href='#popmake-6359'><h4 style='color:#0000ff;'>ГОСТ 14918-2020</h4></a></h4>": "оц.ГОСТ 14918-2020",
        "<h4>2️⃣➖Оцинкованная сталь цинк 8️⃣0️⃣➖1️⃣0️⃣0️⃣ г/м2 стандарт до ➕8️⃣0️⃣°С Кратковременно до ➕2️⃣0️⃣0️⃣°С. Отн. влажность до 60%</h4>": "оц.80",
        "<h4>3️⃣➖Оцинкованная сталь <a href='#popmake-5882'><h4 style='color:#0000ff;'>ГОСТ 14918-80</h4></a> цинк 140 г/м2 <a href='#popmake-5992'><h4 style='color:#0000ff;'>СП 60.13330.2012</h4></a>": "оц.140",
        "<h4>4️⃣➖Оцинкованная сталь <a href='#popmake-5882'><h4 style='color:#0000ff;'>ГОСТ 14918-80</h4></a> цинк 275 г/м2 <a href='#popmake-5992'><h4 style='color:#0000ff;'>СП 60.13330.2012</h4></a>": "оц.275",
        "<h4>5️⃣➖Тонколистовая холоднокатаная (сталь без покрытия) ГОСТ 16523-70, ГОСТ 19903-74 до 80°С</h4>": "оц.тнк ГОСТ-19903-74",
        "<h4>6️⃣➖Оцинкованная сталь - Б Ст3КП по ГОСТ 24751-81</h4>": "оц.Б Ст3КП-24751-81",
        "<h4>7️⃣➖Оцинкованная сталь - Б Ст3КП по ГОСТ 16523–70</h4>": "оц.Б Ст3КП-16523–70",
        "<h4>8️⃣➖Оцинкованная сталь - <img src='https://ilysan.ru/wp-content/themes/mesmerize-child/assets/img/Buttons/SVCtAXT.gif' alt='' style='width: 70px; height: auto;'/>ДЫМОУДАЛЕНИЕ до 500°С (кратковременно до 700°С)</h4>": "оц.дым.",
        "<h4>9️⃣➖Нержавеющая сталь 08Х18Н10 (AISI 304) пищевые, матовые</h4>": "НЖ08Х18Н10(AISI304)пищ.мат",
        "<h4>1️⃣0️⃣➖Нержавеющая сталь 08Х18Н10 (AISI 304) пищевые, зеркальные</h4>": "НЖ08Х18Н10(AISI304)пищ.зерк.",
        "<h4>1️⃣1️⃣➖Нержавеющая сталь 08Х18Н10 (AISI 304) пищевые, шлифованные</h4>": "НЖ08Х18Н10(AISI304)пищ.шлиф.",
        "<h4>1️⃣2️⃣➖Нержавеющая сталь 08Х17, 08Х18Н10 AISI 201 декоративные, рифлёные</h4>": "НЖ08Х17,08Х18Н10дек.риф.",
        "<h4>1️⃣3️⃣➖Нержавеющая сталь 10Х17Н13М2, 03Х17Н13АМ3, AISI 316L кислотостойкие с молибденом</h4>": "НЖ10Х17Н13М2, 03Х17Н13АМ3, AISI 316L кисл.ст.мб",
        "<h4>1️⃣4️⃣➖Нержавеющая сталь 12Х18Н10Т, AISI 321 с содержанием титана</h4>": "НЖ12Х18Н10Т(AISI321тит)",
        "<h4>1️⃣5️⃣➖Нержавеющая сталь 12Х15Г9НД (AISI 201) технические, матовые</h4>": "НЖ12Х15Г9НД(AISI 201)тех.мат",
        "<h4>1️⃣6️⃣➖Нержавеющая сталь 08Х17 (AISI 430) технические, матовые</h4>": "НЖ08Х17(AISI 430)тех.мат.",
        "<h4>1️⃣7️⃣➖Нержавеющая сталь 08Х17 (AISI 430) технические, шлифованные</h4>": "НЖ08Х17(AISI 430)тех.шлиф.",
        "<h4>1️⃣8️⃣➖Нержавеющая сталь 08Х17 (AISI 430) технические, зеркальные</h4>": "НЖ08Х17(AISI 430)тех. зерк.",
        "<h4>1️⃣9️⃣➖Нержавеющая сталь листы жаропрочные</h4>": "нж.л.жп.",
        "<h4>2️⃣0️⃣➖Пластик (химически стойкие)</h4>": "пласт.хим.стойк.",
        "<h4>2️⃣1️⃣➖Чёрная сталь(Аспирация) ГОСТ 16523-97</h4>": "черн.ст.ГОСТ 16523-97",
        "<h4>2️⃣2️⃣➖Материал заказчика</h4>": "мз.",
        "<h4>2️⃣3️⃣➖Алюминий до 200°С (кратковременно до 300°С)</h4>": "ал.",
        "<h4>2️⃣4️⃣➖Текстильные воздуховоды</h4>": "текст.",
        "<h4>2️⃣5️⃣➖Гальванизация</h4>": "глвз",
        "<h4>2️⃣6⃣➖Нержавеющая сталь AISI 316</h4>": "AISI316",
        "<h4>2️⃣7⃣➖Нержавеющая сталь AISI 321</h4>": "AISI321",
        "<h4>2️⃣8⃣➖100% полиэстер с PU-покрытием 160г/м²</h4>": "НЛПс",
        "<h4>2️⃣9⃣➖100% полиэстер с PU-покрытием 220г/м²</h4>": "НПс",
        "<h4>3⃣0⃣➖98% полиэстер огнестойкий антистатический</h4>": "НПсГ1",
        "<h4>3⃣1⃣➖100% полиэфир</h4>": "ППф",
        "<h4>3⃣2⃣➖100% полиэфир слабогорючий</h4>": "ППфГ1",
        "<h4>3⃣3⃣➖100% полиамид</h4>": "ППм",
    };
    return material in materials ? materials[material] : material;
}
export function isPryamik(elem) {
    return elem === 'прямой' || elem === 'прямой прямошовный';
}
export function isPryamikspn(elem) {
    return elem === 'Прямой спирально-навивной';
}
export function getTypedKeys(obj) {
    return Object.keys(obj);
}
export function getLengthByFlange(value) {
    switch (value) {
        case '---':
        case '<h3><img src=\'https://ilysan.ru/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/Отбортовка.png\' class=\'scale\' style=\'width: 50px; height: auto;\' alt=\'Отбортовка\' />Отбортовка 30</h3>':
            return '20';
        case '<h3><img src=\'https://ilysan.ru/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />оц.ш20/у65</h3>':
            return '25';
        case '<h3><img src=\'https://ilysan.ru/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png\' class=\'scale\' alt=\'12-2-1\' />оц.ш30/у105</h3>':
            return '30';
        default:
            return '';
    }
}
export function isChecked(sel, inside) {
    return (inside ? $(sel).find('input[type="checkbox"]:checked') : $(sel)).is(':checked');
}
export function strCompare(s1, s2, char = '%') {
    const isInclude = s2.at(0) === char && s2.at(-1) === char;
    if (isInclude)
        return s1.includes(s2.replaceAll(char, ''));
    else
        return s1 === s2;
}
